import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CitiesDataStatus } from '../../../../shared/models/classes/Dashboard/cityData/city-data-status';
import { DashboardBizzDevService } from '../../../../shared/services/dashboard-bizz-dev.service';

@Component({
    selector: 'app-city',
    templateUrl: './city.component.html',
    styleUrls: ['./city.component.scss']
})
export class CityComponent implements OnInit {
    badCities: CitiesDataStatus;
    displayedColumns = ["fullLabel", "importComparison", "missingRealized", "realizedNotValid"];
    dataSource;
    @ViewChild(MatSort)
    sort: MatSort;
    constructor(private dashboardSrv: DashboardBizzDevService,
                private router: Router) { }

    ngOnInit(): void {
        this.getBadCities();
    }
    getBadCities() {
        this.dashboardSrv
            .getBadCities()
            .subscribe(value => {
                /* filter array to exclude cities with no error */
                let valueFiltered = value.filter(obj =>
                    obj.missingRealized == true || obj.importComparison == true || obj.realizedNotValid == true
                );
                this.dataSource = new MatTableDataSource(valueFiltered);
                if (this.sort) {
                    this.dataSource.sort = this.sort;
                }
            });
    }
    loadCityDetails(id: number) {
        this.router.navigate(['/dashboardBizzDev/details/cityDetails', id]);
    }
}
